import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

import CONFIG from '@webclient/components/pages/config';

export const StyledContainer = styled(Container)(({ theme }) => ({
  height: '100%',

  [theme.breakpoints.up('md')]: {
    maxWidth: theme.spacing(CONFIG.GAMIFICATION.WIDTH_IN_PX / 4),
  },
}));

export const StyledContainerWrapper = styled(Container)(() => ({
  height: '100%',
  position: 'relative',
}));

export const StyledFullHeightStack = styled(Stack)(({ theme }) => ({
  height: '100%',
  paddingBottom: theme.spacing(20), // Hiding behind search bar
}));

export const StyledFlexbox = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 0,
  flexBasis: 'auto',

  // overflow: 'auto', make auto once it does not change the container size
  overflowY: 'scroll',
  paddingLeft: theme.spacing(2), // Compensate for the scrollbar
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  maxWidth: '100%',

  [theme.breakpoints.up('md')]: {
    maxWidth: theme.spacing(CONFIG.GAMIFICATION.WIDTH_IN_PX / 4),
  },

  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translate(-50%, 0px)',
}));
